import { Component } from '@angular/core';

import { PageAction } from '../../components/page-actions/page-actions.component';
import { Router } from '@angular/router';
import { CustomerService } from '@services/customers/customer.service';
import { DataTableEvent } from '../../components/data-table/data-table.component';

@Component({
    selector: 'app-customers',
    templateUrl: './customers.component.html',
    styleUrls: ['./customers.component.scss'],
    providers: [CustomerService],
    standalone: false
})
export class CustomersComponent {

  public title = 'Customers';

  public pageActions: PageAction[];

  public columns = [{ prop: 'company' }];

  constructor(public customerService: CustomerService, private router: Router) {
  }

  public onDetail(event: DataTableEvent): void {
    this.router.navigate(['customers', event.row._id]);
  }

  public onEdit(event: DataTableEvent): void {
    this.router.navigate(['customers', event.row._id, 'edit']);
  }

}
